<template>
  <div>
    <div class="ffPicUploadAjaxBtn">
      <span>上傳圖片</span>
      <input
        :key="inputKey"
        name="files[]"
        type="file"
        accept="image/*"
        @change="onUploadPics($event)"
        multiple
      />
    </div>
    <span class="ffPicUploadAjaxMessage" v-html="message"></span>
  </div>
</template>

<script>
export default {
  props: {
    postMaxSize: {
      type: Number,
      default: 0,
    },
    uploadMaxSize: {
      type: Number,
      default: 0,
    },
    maxFileUploads: {
      type: Number,
      default: 0,
    },
    relatedPicName: {
      type: String,
      default: '',
    },
    defaultMessage: {
      type: String,
      default: '點選 <kbd>CTRL</kbd> 可複選圖片',
    },
    pics: {
      type: Array,
      default: () => {
        return [];
      },
    },
    compressedImg: {
      type: Boolean,
      default: true,
    },
  },
  data: () => {
    return {
      inputKey: 0, // 初始的 key 值
      message: '',
    };
  },
  computed: {},
  methods: {
    // getPicSizeText : function () {
    //     let sizeText = '';

    //     this.thumb.forEach(function(thumb, index, array) {
    //         sizeText += 'w' + thumb.width + 'h' + thumb.height;
    //         if( index != array.length - 1 ) {
    //             sizeText += ',';
    //         }
    //     });

    //     return sizeText;
    // },
    async onUploadPics(event) {
      let sizeTotal = 0;
      let singPicOverLimit = false;
      let uploadItemOverLimit = false;

      for (let i = 0; i < event.target.files.length; i++) {
        if (event.target.files[i].size > this.uploadMaxSize) {
          singPicOverLimit = true;
        }
        if (i > this.maxFileUploads) {
          uploadItemOverLimit = true;
        }
        sizeTotal += event.target.files[i].size;
      }

      if (uploadItemOverLimit) {
        this.message = this.defaultMessage;
        alert(`上傳數量超過限制 ${this.maxFileUploads} 項`);
        return false;
      }

      if ( singPicOverLimit ) {
        this.message = this.defaultMessage;
        alert(
            '單張圖片上傳限制超過' +
            parseInt(this.uploadMaxSize / 1024 / 1024) +
            'M',
        );
        return false;
      }

      if (
        sizeTotal > parseInt(this.postMaxSize)
      ) {
        this.message = this.defaultMessage;
        alert(
          '最大同時上傳限制超過' +
            parseInt(this.postMaxSize / 1024 / 1024) +
            'M',
        );
        return false;
      }

      let params = new FormData();
      for (let i = 0; i < event.target.files.length; i++) {
        params.append('files[]', event.target.files[i]);
      }
      // params.append('thumb', this.getPicSizeText() );
      params.append('relatedPicName', this.relatedPicName);
      params.append('compressedImg', this.compressedImg ? '1' : '0');
      params.append(
        '_token',
        $('meta[name="csrf-token"]').attr('content'),
      );

      this.message = '圖片上傳中...';
      let response;
      try {
        response = await axios.post(
          $('base').attr('href') + 'api/pic/upload',
          params,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        );
      } catch (error) {
        console.warn(error);
        if (error.response && error.response.message) {
          this.message = error.response.message;
        } else {
          console.log(error);
          this.message = '圖片格式錯誤';
        }
        return false;
      }

      let picsData = response.data.pics;

      if (response.data.status === true && picsData) {
        let pics = this.pics;
        for (let i = 0; i < picsData.length; i++) {
          let pic = {
            id: picsData[i].id,
            url: {
              w50h50: picsData[i].url.w50h50,
              w0h0: picsData[i].url.w0h0,
            },
          };
          pics.push(pic);
        }
        this.$emit('onChangePics', pics);
      }

      this.message = this.defaultMessage;
    },
    resetInput() {
      // 當需要重新觸發事件時，可以重新設置 key 值
      this.inputKey++;
    }
  },
  mounted: function () {
    this.message = this.defaultMessage;
  },
};
</script>

<style lang="scss" scoped>
$color-blue: #027de5;

.ffPicUploadAjaxBtn {
  position: relative;
  overflow: hidden;
  margin: 5px 10px 10px 0px;
  display: inline-block;
  *display: inline;
  padding: 0;
  height: 30px;
  font-size: 12px;
  color: #fff;
  text-align: center;
  vertical-align: middle;
  background: $color-blue;
  border: 1px solid $color-blue;
  border-radius: 4px;
  cursor: pointer;
  & > span {
    display: block;
    border: 1px solid #fff;
    border-radius: 4px;
    display: block;
    padding: 0 15px;
    height: 28px;
    line-height: 26px;
    cursor: pointer;
  }
  input {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0;
    border: solid transparent;
    opacity: 0;
    filter: alpha(opacity=0);
    cursor: pointer;
    animation: none;
    transition: none;
    line-height: 30px;
    height: 30px;
  }
  .ffPicUploadAjaxMessage {
    color: #777;
    height: 20px;
    line-height: 20px;
  }
}
</style>
